// Utility function to export clients to CSV/Excel
export const exportClientsToExcel = (clients) => {
    if (!clients || clients.length === 0) {
        return;
    }

    // Prepare headers
    const headers = [
        'ID',
        'Name',
        'First Name',
        'Last Name',
        'Company Name',
        'Email',
        'Phone',
        'Street 1',
        'Street 2',
        'City',
        'State',
        'Zip  Code',
        'Country',
        'Full Address',
        'Type',
        'Status',
        'Average Rating',
    ];

    // Prepare data rows
    const rows = clients.map(client => {
        const rawClient = client.raw || {};
        
        return [
            client.id || '',
            client.name || '',
            rawClient.first_name || '',
            rawClient.last_name || '',
            client.companyName !== '—' ? client.companyName : '',
            client.email || '',
            client.phone || '',
            rawClient.street_1 || '',
            rawClient.street_2 || '',
            client.city !== '—' ? client.city : '',
            client.state || '',
            client.postalCode || '',
            client.country !== '—' ? client.country : '',
            client.fullAddress || '',
            client.tag || '',
            client.status || '',
            client.averageRating || '',
        ];
    });

    // Convert to CSV format
    const csvContent = [
        headers.join(','),
        ...rows.map(row => 
            row.map(cell => {
                // Escape commas and quotes in cell content
                const cellValue = String(cell || '').replace(/"/g, '""');
                return `"${cellValue}"`;
            }).join(',')
        )
    ].join('\n');

    // Create BOM for UTF-8 (Excel compatibility)
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Create download link
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    const timestamp = new Date().toISOString().split('T')[0];
    link.setAttribute('href', url);
    link.setAttribute('download', `clients_export_${timestamp}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up
    URL.revokeObjectURL(url);
};

